import { AuditActionEnum } from '@empathybroker/tsclient-play/dist/enums/audit-action.enum';
import { AuditObjectTypeEnum } from '@empathybroker/tsclient-play/dist/enums/audit-object-type.enum';
import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';
import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../../config';

import { DomainEnum, FeatureIdEnum, FilterIdEnum, FilterTypeEnum } from '../../enums';

import { AppRouteConfig, AuthTokenInfo } from '../../models';

import { AUTH_CONSTS } from '../../store/auth/auth.consts';

import { FeaturesTreeUtils } from '../../utils';

import { Audit } from '../../views';

import { ROUTER_CONSTS } from '../router.consts';

class AuditRoutesUtils {

  public static getObjectTypeFilterValues(instanceConfig: Instance): RegularFilterValueConfig[] {
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    const authTokenInfo: AuthTokenInfo = store.getters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.tokenInfo }`];
    const featuresTree = FeaturesTreeUtils.getFeaturesTree(instanceConfig, authTokenInfo.authorization);
    return Object.values(AuditObjectTypeEnum).reduce((filterValues: RegularFilterValueConfig[], objectType: AuditObjectTypeEnum) => {
      const featureNodeFn = {
        [AuditObjectTypeEnum.EQUALIZE]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.EQUALIZE, featuresTree[DomainEnum.SEARCH]),
        [AuditObjectTypeEnum.BLACKLIST]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.BLACKLIST, featuresTree[DomainEnum.SEARCH]),
        [AuditObjectTypeEnum.PROMOTION]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.PROMOTION, featuresTree[DomainEnum.SEARCH]),
        [AuditObjectTypeEnum.REDIRECTION]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.REDIRECTION,
          featuresTree[DomainEnum.SEARCH]),
        [AuditObjectTypeEnum.SYNONYM]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.SYNONYM, featuresTree[DomainEnum.SEARCH]),
        [AuditObjectTypeEnum.BROWSE_CONFIGURATION]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.CONFIGURATION,
          featuresTree[DomainEnum.BROWSE]),
        [AuditObjectTypeEnum.SEARCH_CONFIGURATION]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.CONFIGURATION,
          featuresTree[DomainEnum.SEARCH]),
        [AuditObjectTypeEnum.INSTANCE]: () => FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.INSTANCE, featuresTree.common)
      }[objectType];
      if (!!featureNodeFn && !!featureNodeFn()) {
        filterValues.push({ id: objectType });
      }
      return filterValues;
    }, []);
  }

}

export const AUDIT_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes.audit,
    path: 'audit',
    component: Audit,
    meta: {
      featureId: FeatureIdEnum.AUDIT,
      filters: (instanceConfig: Instance) => ({
        config: {
          [FilterIdEnum.DATE]: {
            enabled: true
          }
        },
        extra: {
          [FilterIdEnum.AUDIT_OBJECT_TYPE]: {
            id: FilterIdEnum.AUDIT_OBJECT_TYPE,
            type: FilterTypeEnum.REGULAR,
            sortValuesDisabled: true,
            values: AuditRoutesUtils.getObjectTypeFilterValues(instanceConfig)
          },
          [FilterIdEnum.AUDIT_ACTION]: {
            id: FilterIdEnum.AUDIT_ACTION,
            type: FilterTypeEnum.REGULAR,
            sortValuesDisabled: true,
            values: Object.values(AuditActionEnum).map((action: AuditActionEnum) => ({ id: action }))
          }
        }
      })
    }
  }
];
